module.exports = __webpack_public_path__ + "img/sub_introBan_person.5d420ad8.svg";